/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ImageUploadInContentType = typeof ImageUploadInContentType[keyof typeof ImageUploadInContentType];


export const ImageUploadInContentType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
  'image/gif': 'image/gif',
  'image/avif': 'image/avif',
  'image/bmp': 'image/bmp',
  'image/heic': 'image/heic',
} as const;
